const en = {
  nav_timeline: "Timeline",
  nav_invest: "Invest",
  nav_technology: "Technology",
  nav_roadmap: "Roadmap",
  nav_join: "Join Now",
  hero_badge: "Aligned with Artemis Mission Roadmap",
  hero_title_1: "Investing in the",
  hero_title_2: "Future of Lunar",
  hero_title_3: "Civilization",
  hero_subtitle: "ARTEMIDA is a private initiative supporting the next generation of lunar infrastructure aligned with the global Artemis mission roadmap.",
  hero_cta_join: "Join Early Investors",
  hero_cta_whitepaper: "Download Whitepaper",
  hero_stat_1_label: "Mission Milestone",
  hero_stat_2_label: "Development Phases",
  hero_stat_3_label: "Orbital Energy Scale",
  hero_scroll: "Scroll",
  timeline_badge: "Mission Phases",
  timeline_title: "Project Timeline",
  timeline_subtitle: "Four strategic phases building toward a permanent lunar economy and orbital energy network.",
  phase1_name: "ARTEMIDA II",
  phase1_year: "Completed 2026",
  phase1_title: "Crewed Lunar Orbit Mission",
  phase1_desc: "Crewed lunar orbit mission milestone achieved. First successful crewed approach to lunar orbit under the ARTEMIDA private initiative, validating mission architecture and crew systems.",
  phase2_name: "ARTEMIDA III",
  phase2_year: "2027",
  phase2_title: "Lunar Surface Logistics",
  phase2_desc: "Preparation stage for lunar surface logistics infrastructure. Deployment of autonomous cargo systems and surface navigation beacons to support future crewed landings.",
  phase3_name: "ARTEMIDA IV",
  phase3_year: "2028",
  phase3_title: "Permanent Lunar Presence",
  phase3_desc: "Beginning of permanent lunar presence and base deployment support systems. Modular habitat construction begins with life support and power generation infrastructure.",
  phase4_name: "Orbital Solar Network",
  phase4_year: "2030+",
  phase4_title: "Space-Based Solar Infrastructure",
  phase4_desc: "Development of space-based solar infrastructure designed to support long-term lunar economy financing. Orbital arrays transmit clean energy to lunar and Earth-based receivers.",
  status_completed: "Completed",
  status_active: "In Progress",
  status_upcoming: "Upcoming",
  invest_badge: "Investment Case",
  invest_title_1: "Why Invest in",
  invest_subtitle: "The lunar economy is not a distant concept — it is being built now. ARTEMIDA offers a rare entry point into the infrastructure layer of humanity's expansion beyond Earth.",
  invest_global: "Global Artemis Alignment",
  invest_global_sub: "Partnered with international space agencies and private operators",
  reason1_title: "Support Lunar Infrastructure",
  reason1_desc: "Directly fund the physical backbone of humanity's next frontier — from surface logistics to orbital relay systems that will define the lunar economy for decades.",
  reason2_title: "Space Economy Growth",
  reason2_desc: "Participate in the fastest-growing sector of the global economy. The space industry is projected to exceed $1 trillion by 2040, with lunar operations at its core.",
  reason3_title: "Early Ecosystem Access",
  reason3_desc: "Gain early access to the future orbital energy network ecosystem — positioning your portfolio at the intersection of clean energy and space infrastructure.",
  reason4_title: "Strategic Aerospace Positioning",
  reason4_desc: "Secure strategic positioning in next-generation aerospace innovation. ARTEMIDA partners with global institutions and private space companies at the frontier.",
  funding_badge: "Capital Structure",
  funding_title: "Funding Strategy",
  funding_subtitle: "The ARTEMIDA initiative is aligned with future large-scale aerospace financing models and partnerships with global institutions and private space companies supporting lunar logistics and orbital infrastructure expansion.",
  funding_metric1_label: "Target Raise",
  funding_metric1_sub: "Series A & B combined",
  funding_metric2_label: "Strategic Partners",
  funding_metric2_sub: "Global institutions",
  funding_metric3_label: "Infrastructure Allocation",
  funding_metric3_sub: "Direct lunar assets",
  funding_metric4_label: "Revenue Horizon",
  funding_metric4_sub: "Orbital energy sales",
  funding_alloc_title: "Capital Allocation Model",
  funding_alloc1: "Lunar Infrastructure",
  funding_alloc2: "Orbital Solar Development",
  funding_alloc3: "Logistics & Operations",
  funding_alloc4: "R&D & Innovation",
  funding_partners: "Ecosystem Partners & Collaborators",
  partner1: "Space Agencies",
  partner2: "Global Institutions",
  partner3: "Private Space Co.",
  partner4: "Venture Capital",
  partner5: "Orbital Operators",
  partner6: "Tech Partners",
  tech_badge: "Core Systems",
  tech_title: "Technology Vision",
  tech_subtitle: "Four pillars of the ARTEMIDA technological ecosystem, engineered for the long-term lunar economy.",
  tech1_title: "Space-Based Solar Arrays",
  tech1_desc: "Massive photovoltaic arrays deployed in geostationary orbit, capturing uninterrupted solar energy and transmitting it via microwave beams to lunar and terrestrial receivers.",
  tech1_s1: "99.9% uptime",
  tech1_s2: "GW-scale output",
  tech1_s3: "Microwave transmission",
  tech2_title: "Orbital Logistics Systems",
  tech2_desc: "Autonomous orbital transfer vehicles and resupply depots forming a permanent cislunar highway — enabling regular, cost-efficient cargo and crew transport between Earth and the Moon.",
  tech2_s1: "Autonomous ops",
  tech2_s2: "Reusable vehicles",
  tech2_s3: "72hr Earth-Moon transit",
  tech3_title: "Lunar Support Infrastructure",
  tech3_desc: "Modular pressurized habitats, regolith-based construction systems, and autonomous surface vehicles forming the physical foundation of a permanent lunar settlement.",
  tech3_s1: "Regolith construction",
  tech3_s2: "Modular habitats",
  tech3_s3: "Autonomous rovers",
  tech4_title: "Space Economy Framework",
  tech4_desc: "A next-generation economic layer integrating tokenized resource rights, orbital energy trading, and decentralized governance for the emerging cislunar marketplace.",
  tech4_s1: "Tokenized assets",
  tech4_s2: "Energy trading",
  tech4_s3: "DAO governance",
  roadmap_badge: "Strategic Timeline",
  roadmap_title: "Roadmap",
  roadmap_subtitle: "A clear path from orbital milestone to full-scale lunar economy — built on verified progress.",
  rm1_title: "Orbital Mission Milestone Achieved",
  rm1_detail: "ARTEMIDA II successfully completes crewed lunar orbit. Mission architecture validated. Investor confidence secured.",
  rm2_title: "Lunar Mission Preparation Stage",
  rm2_detail: "ARTEMIDA III begins surface logistics preparation. Autonomous cargo systems deployed. Beacon network established.",
  rm3_title: "Lunar Infrastructure Expansion Phase",
  rm3_detail: "ARTEMIDA IV initiates permanent base deployment. Modular habitats, power systems, and surface operations commence.",
  rm4_title: "Orbital Solar Energy Scaling Strategy",
  rm4_detail: "Full deployment of space-based solar arrays. Orbital energy trading begins. Lunar economy reaches self-sustaining threshold.",
  token_badge: "Token Economics",
  token_title: "Token Utility",
  token_subtitle: "The ARTEMIDA token is the economic backbone of the lunar infrastructure ecosystem — powering access, governance, and growth.",
  token1_title: "Access to Ecosystem Services",
  token1_desc: "Token holders gain priority access to ARTEMIDA platform services, orbital data feeds, and lunar infrastructure utilization rights.",
  token2_title: "Governance Participation",
  token2_desc: "Vote on key project decisions including mission priorities, capital allocation, and partnership approvals through decentralized governance.",
  token3_title: "Infrastructure Funding Layer",
  token3_desc: "Tokens serve as the primary instrument for funding lunar and orbital infrastructure projects, with proportional returns tied to asset performance.",
  token4_title: "Space Economy Integration",
  token4_desc: "Seamlessly integrated into the emerging cislunar economy — enabling energy trading, resource rights, and cross-platform interoperability.",
  token_supply: "Total supply: <strong>1,000,000,000 ARTM</strong> — distributed across infrastructure funding, ecosystem rewards, team vesting, and public sale tranches.",
  cta_badge: "Early Access",
  cta_title_1: "Join the ARTEMIDA",
  cta_title_2: "Early Supporter Program",
  cta_subtitle: "Secure your position in the first wave of lunar infrastructure investors. Limited early access slots available.",
  form_join_title: "Join Early Investors",
  form_first_name: "First Name",
  form_last_name: "Last Name",
  form_email: "Email",
  form_org: "Organization",
  form_org_placeholder: "Fund / Company name",
  form_interest: "Investment Interest",
  form_interest_placeholder: "Select range",
  form_message: "Message (optional)",
  form_message_placeholder: "Tell us about your investment thesis...",
  form_submit_join: "Apply for Early Access",
  form_submitting: "Submitting...",
  form_success_join_title: "Application Received",
  form_success_join_sub: "Our team will contact you within 48 hours.",
  form_wp_title: "Download Whitepaper",
  form_full_name: "Full Name",
  form_full_name_placeholder: "Your full name",
  form_email_placeholder: "your@email.com",
  form_role: "Role",
  form_role_placeholder: "Select your role",
  form_role_investor: "Investor",
  form_role_analyst: "Analyst / Researcher",
  form_role_media: "Media / Press",
  form_role_partner: "Potential Partner",
  form_role_other: "Other",
  form_country: "Country",
  form_country_placeholder: "United States",
  form_wp_file: "ARTEMIDA Whitepaper v2.1",
  form_wp_file_sub: "48 pages · PDF · 12.4 MB",
  form_submit_wp: "Request Whitepaper",
  form_success_wp_title: "Whitepaper Sent",
  form_success_wp_sub: "Check your inbox for the ARTEMIDA whitepaper.",
  // Reviews
  reviews_badge: "Client Reviews",
  reviews_title: "What Investors Say",
  reviews_subtitle: "Real reviews from clients across different countries who have received their payouts.",
  reviews_verified: "Verified",
  reviews_stat1: "Satisfied Clients",
  reviews_stat2: "Days to Payout",
  reviews_stat3: "Successful Contracts",

  // Calculator
  calc_badge: "Profit Calculator",
  calc_title: "Calculate Your Profit",
  calc_subtitle: "Select a contract or enter your own amount and see the exact payout within 3 business days.",
  calc_select_contract: "Select Contract",
  calc_custom_amount: "Or Enter Your Amount",
  calc_custom_placeholder: "e.g. 45000",
  calc_custom_note: "Yield is calculated based on the selected contract terms",
  calc_payout_label: "Payout in 3 Business Days",
  calc_payout_desc: "Funds are transferred automatically upon contract completion",
  calc_your_investment: "Your Investment",
  calc_yield_label: "yield",
  calc_initial: "Initial Amount",
  calc_profit: "Profit",
  calc_total_payout: "Total Payout",
  calc_days_note: "Payout within 3 business days after contract activation",
  calc_stat_days: "Business Days",
  calc_stat_yield: "Yield",
  calc_stat_currency: "Currency",
  calc_min_amount: "Minimum amount",
  livefeed_received: "received a payout",

  // Contracts Section
  contract_badge: "Investment Terms",
  contract_title_1: "Financial",
  contract_title_2: "Participation Contracts",
  contract_subtitle: "ARTEMIDA offers structured investment contracts backed by SpaceX operational capital. Choose your tier and receive payout within 3 business days.",
  contract_collateral_title: "Collateral & Credit Structure",
  contract_collateral_sub: "SpaceX manages the collateral structure and credit mechanism of the initiative",
  contract_collateral_amount: "Collateral Amount",
  contract_credit_amount: "Credit Line",
  contract_operator: "Operator",
  contract_popular: "Popular",
  contract_tier_entry: "Entry",
  contract_tier_growth: "Growth",
  contract_tier_premium: "Premium",
  contract_investment: "Investment",
  contract_yield: "Yield",
  contract_return: "Profit",
  contract_total: "Total Payout",
  contract_payout: "Payout Term",
  contract_days: "business days",
  contract_select: "Select Contract",
  contract_disclaimer: "All contracts are conceptual investment instruments within the ARTEMIDA initiative. Investment in space infrastructure involves significant risk. Past performance does not guarantee future returns.",
  contract_modal_title: "Contract Details",
  contract_modal_desc: "To participate in this investment contract, contact our team via the early investor form below.",
  contract_modal_note: "All contracts are subject to identity verification and compliance with applicable law.",
  contract_modal_close: "Understood",

  // SpaceX Section
  spx_badge: "Strategic Alignment",
  spx_title_1: "Aligned with the Vision of",
  spx_title_2: "SpaceX & Elon Musk",
  spx_subtitle: "ARTEMIDA is directly positioned within SpaceX's orbital solar strategy. Elon Musk announced a target of 100 gigawatts of orbital solar power within 30 months — ARTEMIDA is the infrastructure layer that will support this revolution.",
  spx_stat1_label: "SpaceX Target Output",
  spx_stat1_sub: "Annual orbital solar energy production target by end of 2028",
  spx_stat2_label: "Higher Efficiency in Orbit",
  spx_stat2_sub: "Space-based solar stations produce 5× more energy than ground-based equivalents",
  spx_stat3_label: "Months to Deployment",
  spx_stat3_sub: "Musk: orbital solar will become the most cost-effective energy method within 30 months",
  spx_stat4_label: "Orbital Uptime",
  spx_stat4_sub: "No night, no clouds — continuous 24/7 solar energy capture in orbit",
  spx_quote: "Within 30 months, space-based solar energy will become the most cost-effective method of energy production. Starship can deliver 300–500 GW of solar-powered satellites to orbit annually.",
  spx_intro: "SpaceX and Tesla are working toward manufacturing 100 GW of solar cells annually. Starship, carrying 200 tons per flight, will deploy massive orbital solar arrays — directly powering ARTEMIDA's lunar infrastructure and AI data centers on Earth.",
  spx_fact1_title: "Starship — The Deployment Engine",
  spx_fact1_desc: "Starship carries 200 tons per flight and can deliver 300–500 GW of solar satellites to orbit annually. Launch costs drop to $100–200/kg, making 10 GW orbital solar stations financially viable with projected costs of ~3.8¢/kWh at maturity.",
  spx_fact2_title: "×5 Efficiency: The Physics of Orbital Energy",
  spx_fact2_desc: "In orbit, solar panels capture energy 99% of the time — no night, no clouds, no atmospheric diffusion. Solar intensity is 40% higher, and annual energy yield is up to 13× greater than an identical ground-based installation.",
  spx_fact3_title: "100 GW by End of 2028",
  spx_fact3_sub: "Musk announced at WEF 2026 that SpaceX and Tesla are independently working toward 100 GW annual solar cell manufacturing capacity in the US.",
  spx_fact3_desc: "Musk announced at the World Economic Forum 2026 that SpaceX and Tesla are independently working toward building 100 GW annual solar cell manufacturing capacity in the US — to power AI and lunar infrastructure.",
  spx_compare_title: "Efficiency: Ground-Based vs. Orbital Solar Energy",
  spx_compare_ground: "Ground-based solar station",
  spx_compare_orbit: "Orbital solar station (SpaceX)",
  spx_compare_note: "Orbital solar stations generate up to 13× more energy annually than an identical ground installation due to continuous exposure and no atmospheric diffusion. Projected cost: ~3.8¢/kWh at maturity.",

  footer_tagline: "Space Innovation | Lunar Infrastructure | Orbital Energy Future",
  footer_rights: "© 2026 ARTEMIDA Initiative. All rights reserved.",
  footer_disclaimer: "This website is for informational purposes only and does not constitute financial advice or an offer to sell securities. Investment in space infrastructure involves significant risk.",
};

export default en;
